import 'css-chunksrc/client/scenes/strategicAxisEdition/form/tag/styles.scss';export default {
  "tag": "_tag_kt7wc_1"
};